<template>
  <form @submit.prevent="executeCaptcha" novalidate>
    <div class="newsletter-input" :class="{ 'has-error': errors.first('subject') }">
      <div class="newsletter-input">
        <input
          id="newsletter_email"
          name="email"
          v-model="form.email"
          class="newsletter"
          placeholder="Please enter your email"
          type="email"
          v-validate="'required|email'"
        >
        <button type="submit" v-bind:class="{ loading: applyingForm }">
          <i v-if="applyingForm == false" class="icon-check"></i>
          <div v-if="applyingForm == true" class="loader-dots">
            <span class="loader-dot">.</span>
            <span class="loader-dot">.</span>
            <span class="loader-dot">.</span>
          </div>
        </button>
      </div>
      <div class="mt-1 mr-1" style="position: absolute;">
        <p v-cloak v-if="responseMsg" class="error-msg text-white xxxsmall font-weight-thin">{{responseMsg}}</p>
        <p v-cloak class="error-msg text-white xxxsmall font-weight-thin">{{ errors.first('email') }}</p>
      </div>
    </div>

    <vue-recaptcha
      ref="recaptcha"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      size="invisible"
      v-bind:sitekey="captchakey"
    ></vue-recaptcha>
  </form>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import veeValidate from "vee-validate";
import { Validator } from "vee-validate";
Vue.use(veeValidate);
Vue.use(VueRecaptcha);

// CUSTOM ERROR MESSAGES
const dict = {
  custom: {
    email: {
      required: "Field is required",
      email: "Must be a valid email"
    }
  }
};

Validator.localize("en", dict);

export default {
  props: {
    actionroute: {
      type: String,
      required: true
    },
    captchakey: {
      type: String,
      required: true
    }
  },
  components: {
    "vue-recaptcha": VueRecaptcha,
    "vee-validate": Validator
  },
  data() {
    return {
      form: {
        email: "",
        "g-recaptcha-response": ""
      },
      responseMsg: "",
      applyingForm: false,
      action: this.actionroute
    };
  },
  watch: {
    // whenever question changes, this function will run
    message: function(newmessage, oldmessage) {
      if (newmessage != "") {
        setTimeout(function() {
          newmessage = "";
        }, 2000);
      }
    }
  },
  methods: {
    executeCaptcha(event) {
      this.applyingForm = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.recaptcha.execute();
        } else {
          console.log(
            "Error: ",
            "#newsletter_" + this.$validator.errors.items[0].field
          );
          document.querySelector("#newsletter_email").focus();
          this.applyingForm = false;
        }
      });
    },

    onCaptchaVerified(token) {
      this.form["g-recaptcha-response"] = token;
      this.submitForm();
    },

    onCaptchaExpired: function() {
      this.$refs.recaptcha.reset();
    },

    resetCaptcha() {
      this.$refs.recaptcha.reset();
    },

    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var data = new FormData();
          for (var prop in this.form) {
            if (this.form.hasOwnProperty(prop)) {
              data.append(prop, this.form[prop]);
            }
          }
          // p.ntymenos@gmail.com
          this.$http
            .post(this.action, data, {
              headers: {
                "Content-Type":
                  "multipart/form-data; charset=utf-8; boundary=" +
                  Math.random()
                    .toString()
                    .substr(2)
              }
            })
            .then(
              function(dataSucc) {
                this.responseMsg = dataSucc.body.message;
                this.responseClass = "form-success";
                this.applyingForm = false;
                this.clearForm();
                this.resetCaptcha();
                var self = this;
                setTimeout(function() {
                  self.responseMsg = "";
                }, 5000);
              },
              function(dataError) {
                this.responseMsg = dataError.body.message;
                this.responseClass = "form-danger";
                this.applyingForm = false;
                this.clearForm();
                this.resetCaptcha();
                var self = this;
                setTimeout(function() {
                  self.responseMsg = "";
                }, 5000);
              }
            );
        } else {
          this.responseMsg = "Check the fields for errors.";
          this.responseClass = "text-danger";
          console.log("Error: ", result);
        }
      });
    },

    clearForm() {
      this.form = {
        email: "",
        "g-recaptcha-response": ""
      };
      this.applyingForm = false;
      this.$validator.reset();
    }
  }
};
</script>

<style lang="scss">
@keyframes blink {
  50% {
    color: transparent;
    background: transparent;
  }
}

.newsletter button.loading:before {
  display: none;
}

.loader-dot {
  font-size: 32px;
  color: #000;
  line-height: 0px;
  vertical-align: top;
  position: relative;
}

.newsletter button.loading:hover .loader-dot {
  color: #da2128;
}

.loader-dot {
  animation: 1s blink infinite;
}
.loader-dot:nth-child(2) {
  animation-delay: 250ms;
}
.loader-dot:nth-child(3) {
  animation-delay: 500ms;
}

.newsletter .input-wrapper {
  overflow: visible;
}
.newsletter #email-error,
.newsletter #email-response {
  position: absolute;
  top: 55px;
  z-index: 9999;
  color: #fff;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/js/components/newsletter-form/newsletter-form.vue